import { Controller } from "@hotwired/stimulus"

const euros = new Intl.NumberFormat("en-GB", { style: "currency", currency: "EUR", maximumFractionDigits: 0 })
const compact = new Intl.NumberFormat("en-GB", { style: "currency", currency: "EUR", notation: "compact", maximumFractionDigits: 1 })

export default class extends Controller {
  static targets = ["canvas", "swatch"]
  static values = { labels: Array, series: Array, putIn: Array }

  connect() {
    const lines = this.seriesValue.map((series, index) => ({
      label: series.label,
      data: series.data,
      borderColor: getComputedStyle(this.swatchTargets[index]).color,
      borderWidth: 2,
      fill: false,
      pointRadius: 0,
      pointHoverRadius: 4,
      lineTension: 0
    }))

    this.chart = new window.Chart(this.canvasTarget.getContext("2d"), {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: [
          ...lines,
          {
            label: "Put in",
            data: this.putInValue,
            borderColor: "rgba(255, 255, 255, 0.4)",
            borderWidth: 2,
            borderDash: [6, 6],
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            lineTension: 0
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        animation: false,
        legend: { display: false },
        hover: { mode: "index", intersect: false },
        tooltips: {
          mode: "index",
          intersect: false,
          backgroundColor: "#fff",
          titleFontColor: "#333",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          callbacks: {
            label: (item, data) => `${data.datasets[item.datasetIndex].label}: ${euros.format(item.yLabel)}`
          }
        },
        scales: {
          yAxes: [{
            gridLines: { drawBorder: false, color: "rgba(255, 255, 255, 0.06)", zeroLineColor: "rgba(255, 255, 255, 0.06)" },
            ticks: { beginAtZero: true, maxTicksLimit: 5, padding: 8, fontColor: "#9a9a9a", callback: (value) => compact.format(value) }
          }],
          xAxes: [{
            gridLines: { display: false, drawBorder: false },
            ticks: { maxTicksLimit: 8, maxRotation: 0, padding: 8, fontColor: "#9a9a9a", callback: (label) => label.slice(-4) }
          }]
        }
      }
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
